import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Layout } from "antd";
import "./HomePage.css";
import "../AntDesignStyle.css";
import Headerbar from "../header/Headerbar";
import Sidebar from "../sidebar/Sidebar";
import Dashboard from "../dashboard/Dashboard";
import AccountListPage from "../accountList/AccountListPage";
import AccountListPageForm from "../accountList/form/AccountListPageForm";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { loginReducerAction } from "../../store/loginReducer";
import jwt_decode from "jwt-decode";
import { errorNotificationAlert } from "../notificationAlert/noticationAlert";
import { HOMEPAGE_CONSTANT } from "../../constant/homepage.constant";
import loginService from "../../service/loginService";
import ResourceListPage from "../resourceList/ResourceListPage";
import ResourceListAddForm from "../resourceList/form/ResourceListAddForm";
import ResourceListEditForm from "../resourceList/form/ResourceListEditForm";
import ResourceListDetailForm from "../resourceList/form/ResourceListDetailForm";
import { ROUTER_CONSTANT } from "../../constant/router.constant";

const HomePage = () => {
  const { Header, Content } = Layout;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.loginData.token);

  useEffect(() => {
    const checkExpiredToken = () => {
      let timeToday = Date.now();
      let expTimeJwtToken = (jwt_decode(token).exp * 1000);
  
      if (timeToday >= expTimeJwtToken) {
        errorNotificationAlert(
          HOMEPAGE_CONSTANT.NOTIFICATION_ERROR_TITLE,
          HOMEPAGE_CONSTANT.NOTIFICATION_ERROR_CONTENT_EXP_TOKEN,
          HOMEPAGE_CONSTANT.NOTIFICATION_ERROR_CONTENT_DETAIL_EXP_TOKEN
        );
        return true;
      }
      return false;
    }

    if (!token || checkExpiredToken()) {
      dispatch(loginReducerAction.onLogout());
      loginService.logout();
      navigate("/");
    }
  }, [token, dispatch, navigate]);

  return (
    <Layout className="layout-container">
      <Header className="headerbar-style">
        <Headerbar />
      </Header>

      <Layout>
        <Sidebar />

        <Layout style={{ overflow: "auto" }}>
          <Content>
            <div className="card-container-content">
              <Routes>
                <Route
                  path={`/*`}
                  element={<Navigate to={`${ROUTER_CONSTANT.HOME}`} />}
                />
                <Route path={`/`} element={<Dashboard />} />
                <Route path={`${ROUTER_CONSTANT.ACCOUNT_LIST}`} element={<AccountListPage />} />
                <Route path={`${ROUTER_CONSTANT.ACCOUNT_LIST_ID}`} element={<AccountListPageForm />} />
                <Route path={`${ROUTER_CONSTANT.RESOURCE_LIST}`} element={<ResourceListPage />} />
                <Route path={`${ROUTER_CONSTANT.RESOURCE_LIST_ADD}`} element={<ResourceListAddForm />} />
                <Route path={`${ROUTER_CONSTANT.RESOURCE_LIST_EDIT}`} element={<ResourceListEditForm />} />
                <Route path={`${ROUTER_CONSTANT.RESOURCE_LIST_DETAIL}`} element={<ResourceListDetailForm />} />
                <Route path={`${ROUTER_CONSTANT.RESOURCE_LIST_DELETE}`} element={<ResourceListDetailForm />} />
              </Routes>
            </div>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  )
}

export default HomePage;